import styles from "./styles.scss";
import { FC, PropsWithChildren } from "react";
import clsx from "clsx";
import { IconButton } from "../icon-button";
import { Chevron, Cross } from "@/assets/icons";
import { Modal } from "../modal";
import { SideDrawerProps } from "./types";
import { DrawerVariant, ANIMATION_DURATION } from "@/constants/drawer";
import { getApplicationRoot } from "@/utils";
import { noop } from "lodash";

export const SideDrawer: FC<PropsWithChildren<SideDrawerProps>> = ({
  title,
  children,
  header,
  headerContent,
  headerExtraContent,
  className,
  overlayClassName,
  headerClassName,
  headerWrapperClassName,
  titleClassName,
  closeIconClassName,
  CloseIcon = Cross,
  isCloseIconVisible = true,
  onBack,
  onClose,
  variant = DrawerVariant.Primary,
  ...props
}) => {
  const isSecondary = variant === DrawerVariant.Secondary;

  const handleCloseRequest = onClose ?? onBack ?? noop;

  const defaultHeader = (
    <div
      className={clsx(
        styles.header,
        isSecondary && styles.secondaryHeader,
        headerClassName,
      )}
    >
      {onBack && (
        <IconButton
          icon={Chevron}
          onClick={onBack}
          className={clsx(
            styles.backButton,
            isSecondary && styles.secondaryButton,
            closeIconClassName,
          )}
        />
      )}

      {title && (
        <h4 className={clsx(styles.titleText, titleClassName)}>{title}</h4>
      )}

      <div
        className={clsx(
          styles.headerActionWrapper,
          isSecondary && styles.secondaryHeaderActionWrapper,
        )}
      >
        {headerContent && headerContent()}

        {onClose && isCloseIconVisible && (
          <IconButton
            icon={CloseIcon}
            className={clsx(styles.closeButton, closeIconClassName)}
            iconClassName={styles.closeIcon}
            onClick={onClose}
          />
        )}
      </div>
    </div>
  );

  return (
    <Modal
      {...props}
      className={clsx(
        styles.modal,
        isSecondary && styles.secondaryModal,
        className,
      )}
      overlayClassName={clsx(styles.overlay, overlayClassName)}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      onRequestClose={handleCloseRequest}
      closeTimeoutMS={ANIMATION_DURATION}
      appElement={getApplicationRoot()}
    >
      <header
        className={clsx(headerWrapperClassName && headerWrapperClassName)}
      >
        {header ? header : defaultHeader}
        {headerExtraContent && headerExtraContent()}
      </header>
      <div className={styles.scrollBody}>{children}</div>
    </Modal>
  );
};
